import { Link } from "@tanstack/react-router";
import { Card, Group, Stack, Text } from "@/components/ui";
import type { DocumentoAuditEntry } from "../services/auditoria-service";
import { formatBytes } from "../utils/format-helpers";
import { AccionBadge } from "./AccionBadge";

export function DocumentoAuditMobileCard({ entry }: { entry: DocumentoAuditEntry }) {
  return (
    <Card padding="md">
      <Stack gap="xs">
        <Group justify="space-between" align="flex-start" className="flex-nowrap">
          <div className="min-w-0 flex-1">
            <Text size="xs" c="dimmed">
              {new Date(entry.ocurridoAt).toLocaleString()}
            </Text>
            <Link
              to="/solicitudes/$id"
              params={{ id: entry.solicitudId } as never}
              className="block font-mono text-sm text-multiva-600 hover:underline"
            >
              Solicitud #{entry.numeroSolicitud}
            </Link>
            <Text fw={500} truncate className="mt-1" title={entry.nombreOriginal}>
              {entry.nombreOriginal}
            </Text>
          </div>
          <AccionBadge accion={entry.accion} />
        </Group>
        <div className="grid grid-cols-2 gap-1">
          <Text size="xs" c="dimmed">
            Categoría
          </Text>
          <Text size="xs" ta="right">
            {entry.categoria}
          </Text>
          <Text size="xs" c="dimmed">
            Tamaño
          </Text>
          <Text size="xs" ta="right" className="font-mono">
            {formatBytes(entry.tamanoBytes)}
          </Text>
          <Text size="xs" c="dimmed">
            Usuario
          </Text>
          <Text size="xs" ta="right" truncate title={entry.usuarioId}>
            {entry.usuarioNombre ?? entry.usuarioId.slice(0, 8) + "…"}
          </Text>
          {entry.motivoEliminacion ? (
            <>
              <Text size="xs" c="dimmed">
                Motivo
              </Text>
              <Text size="xs" ta="right">
                {entry.motivoEliminacion}
              </Text>
            </>
          ) : null}
        </div>
      </Stack>
    </Card>
  );
}
